import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { AnimatePresence } from 'framer-motion';
import Header from '../Header';
import Footer from '../Footer';
import BookingSection from '../BookingSection';
import NewsletterSignup from '../NewsletterSignup';
import CookieConsent from '../CookieConsent';
import ChatWidget from '../ChatWidget';
import ImpressumPage from '../ImpressumPage';
import DatenschutzPage from '../DatenschutzPage';
import AGBPage from '../AGBPage';

/**
 * Gemeinsamer Layout-Wrapper für alle SEO-Pillar-Pages.
 * Übernimmt Header, Footer, Booking, Newsletter, Cookie, Modals.
 * Pillar-Content selbst wird als children gerendert.
 */
export default function PillarLayout({
  title,
  description,
  canonical,
  schemaLd,
  children,
}) {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);
  const [showAGB, setShowAGB] = useState(false);

  useEffect(() => {
    const ds = () => setShowDatenschutz(true);
    const agb = () => setShowAGB(true);
    window.addEventListener('openDatenschutz', ds);
    window.addEventListener('openAGB', agb);
    return () => {
      window.removeEventListener('openDatenschutz', ds);
      window.removeEventListener('openAGB', agb);
    };
  }, []);

  return (
    <>
      <Helmet>
        <html lang="de" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content="de_DE" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {schemaLd && (
          <script type="application/ld+json">{JSON.stringify(schemaLd)}</script>
        )}
      </Helmet>

      <Header />
      <main className="bg-white">
        {children}
      </main>
      <BookingSection />
      <NewsletterSignup />
      <Footer
        onImpressum={() => setShowImpressum(true)}
        onDatenschutz={() => setShowDatenschutz(true)}
        onAGB={() => setShowAGB(true)}
      />
      <CookieConsent onPrivacy={() => setShowDatenschutz(true)} />
      <ChatWidget />
      <AnimatePresence>
        {showImpressum && <ImpressumPage onClose={() => setShowImpressum(false)} />}
        {showDatenschutz && <DatenschutzPage onClose={() => setShowDatenschutz(false)} />}
        {showAGB && <AGBPage onClose={() => setShowAGB(false)} />}
      </AnimatePresence>
    </>
  );
}
